<template>
  <div>
    <v-dialog
      v-model="dialogConfirm.open"
      @keydown.esc="dialogConfirm.open = false"
      persistent
      content-class="small"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <v-col cols="12" sm="12" md="12" lg="12">
              <p v-html="dialogConfirm.message"></p>
            </v-col>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="btn-close"
            class="btn-secondary"
            @click="dialogConfirm.open = false"
          >
            Cancel
          </v-btn>
          <v-btn id="btn-close" class="btn-primary" @click="dialogConfirmClick">
            {{ btnSave }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'DialogConfirmTab',
  props: {
    dialogConfirm: Object
  },
  computed: {
    btnSave() {
      switch (this.dialogConfirm.action) {
        case 'clearAll':
          return 'Clear all'
        case 'restore':
          return 'Restore'
        case 'overwrite':
          return 'Overwrite'
        default:
          return 'Delete'
      }
    }
  },
  methods: {
    dialogConfirmClick() {
      this.$emit('dialogConfirmClick', this.dialogConfirm.action)
    }
  }
}
</script>
